import  { useState } from 'react';
import { usePushNotifications } from '../../hooks/notificationHooks/usePushNotifications'; // Adjust path
import { Bell, BellOff, Loader2 } from 'lucide-react';

export const ExpertNotificationToggle = () => {
  // 🟢 Everything comes from the hook now
  const { isSupported, isSubscribed, subscribeToPush, unsubscribeFromPush} = usePushNotifications();
  
  // 🟢 NEW: Added loading state to prevent multiple clicks
  const [isLoading, setIsLoading] = useState(false);

  if (!isSupported) {
    return (
      <div className="p-4 bg-slate-50 border border-slate-200 rounded-xl text-sm text-slate-500 italic">
        Push notifications are not supported in your browser.
      </div>
    );
  }

  // 🟢 NEW: Wrapper function to handle the loading state
  const handleToggle = async () => {
    if (isLoading) return; // Prevent double clicks
    
    setIsLoading(true);
    try {
      if (isSubscribed) {
        await unsubscribeFromPush();
      } else {
        await subscribeToPush();
      }
    } catch (error) {
      console.error("Error toggling notifications:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 p-5 bg-white border border-slate-200 rounded-xl shadow-sm">
      
      {/* Status Info */}
      <div className="flex items-center gap-3">
        <div className={`p-2 rounded-full ${isSubscribed ? 'bg-indigo-100 text-indigo-600' : 'bg-slate-100 text-slate-400'}`}>
          {isSubscribed ? <Bell className="w-5 h-5" /> : <BellOff className="w-5 h-5" />}
        </div>
        <div>
          <h3 className="text-sm font-bold text-slate-900">Desktop Notifications</h3>
          <p className="text-xs text-slate-500 mt-0.5">
            {isSubscribed 
              ? 'You will receive alerts for new bookings and chats.' 
              : 'Turn on to get instantly notified of new activity.'}
          </p>
        </div>
      </div>

      {/* Action Buttons */}
      <div className="flex items-center gap-3 w-full sm:w-auto">
        
        {/* 🟢 The test button JSX has been removed from the UI so the expert doesn't see it, but all your logic above remains untouched. */}
        
        <button 
          onClick={handleToggle}
          disabled={isLoading}
          className={`flex-1 sm:flex-none px-5 py-2 text-sm font-bold rounded-lg transition-all shadow-sm flex items-center justify-center gap-2 disabled:opacity-70 disabled:cursor-not-allowed ${
            isSubscribed 
              ? 'bg-red-50 text-red-600 hover:bg-red-100 border border-red-100' 
              : 'bg-indigo-600 text-white hover:bg-indigo-700'
          }`}
        >
          {isLoading ? (
            <>
              <Loader2 className="w-4 h-4 animate-spin" />
              {isSubscribed ? 'Disabling...' : 'Enabling...'}
            </>
          ) : (
            isSubscribed ? 'Disable' : 'Enable Notifications'
          )}
        </button>
      </div>

    </div>
  );
};